import { SvgIcon, SvgIconProps } from '@mineral/core';
import React from 'react';

export const AccessChangedIcon: React.FC<SvgIconProps> =
  React.forwardRef<SVGSVGElement>((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      width="342"
      height="243"
      viewBox="0 0 342 243"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2111_10866)">
        <g clip-path="url(#clip1_2111_10866)">
          <path
            d="M260.812 101.46H78.2598V242.874H260.812V101.46Z"
            fill="#A8B2E6"
          />
          <path
            d="M266.181 96.2927H72.8906V159.967H266.181V96.2927Z"
            fill="#A8B2E6"
          />
          <path
            opacity="0.46"
            d="M260.519 159.967H78.5205V166.622H260.519V159.967Z"
            fill="#6D7CC9"
          />
          <path
            d="M194.169 95.9397H144.936V242.874H194.169V95.9397Z"
            fill="#E1E5F5"
          />
          <path
            d="M152.582 59.9184C131.365 36.4755 78.5198 31.938 76.7301 58.179C74.9404 84.4199 169.763 96.9985 169.763 96.9985C169.763 96.9985 167.258 76.1268 152.582 59.9184ZM97.0353 63.0694C101.981 46.987 128.795 48.0961 143.471 62.0863C158.146 76.0764 161.173 94.5535 161.173 94.5535C161.173 94.5535 90.6899 83.6891 97.0353 63.0694V63.0694Z"
            fill="#E1E5F5"
          />
          <path
            d="M169.341 96.9983C169.341 96.9983 264.196 84.3945 262.374 58.1787C260.552 31.963 207.739 36.4753 186.522 59.9182C171.846 76.1266 169.341 96.9983 169.341 96.9983ZM177.931 94.4775C177.931 94.4775 181.186 75.95 195.634 62.0103C210.081 48.0706 237.123 46.8859 242.069 62.9934C248.316 83.6888 177.931 94.5532 177.931 94.5532V94.4775Z"
            fill="#E1E5F5"
          />
        </g>
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M333 94C333 71.92 315.08 54 293 54C270.92 54 253 71.92 253 94C253 116.08 270.92 134 293 134C315.08 134 333 116.08 333 94ZM286.223 112.273L286.107 112.157L286.086 112.178L267.485 93.5758C265.946 92.0372 265.946 89.5426 267.485 88.004C269.023 86.4653 271.518 86.4653 273.056 88.004L286.202 101.15L309.82 77.5329C311.358 75.9942 313.853 75.9942 315.392 77.5329C316.93 79.0715 316.93 81.5661 315.392 83.1047L286.223 112.273Z"
        fill="#2A854E"
      />
      <defs>
        <clipPath id="clip0_2111_10866">
          <rect width="342" height="243" fill="white" />
        </clipPath>
        <clipPath id="clip1_2111_10866">
          <rect
            width="193.29"
            height="202.542"
            fill="white"
            transform="translate(72.8906 40.332)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  ));
